import { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { useMediaQuery } from "react-responsive"; 
import Cards from "./Card";
import axios from "axios";
import { API_URL } from "../API/config";
import { message } from "antd";

export default function Hotdeal() {
  const [startIndex, setStartIndex] = useState(0);
  const [messageApi, contextHolder] = message.useMessage();
  const [data, setData] = useState<any[]>([]);
  const [filteredData, setFilteredData] = useState<any[]>([]);



  const errormessage = (content: any) => {
    messageApi.open({
      type: "error",
      content: content,
      className: "custom-class",
    });
  };

  // Use media query to check if the device width is small
  const isSmallDevice = useMediaQuery({ maxWidth: 768 });
  const visibleCount = isSmallDevice ? 2 : 3; 


  const getProduct = async () => {
       const token = sessionStorage.getItem("token");
     
    try {
      const res = await axios.get(`${API_URL}/api/products`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      
      const bestProd = res.data.filter((val: any) => val.categories === "smart-phone");
      setData(bestProd);
      setFilteredData(bestProd);
    } catch (error:any) {
      errormessage(error.message || "Failed to load products.");
    }
  };

  useEffect(() => {
    getProduct();
  }, []);

  return (
    <>
      {contextHolder}
      <section className="py-4 ">
        <Container >
          <div className=" justify-content-between align-items-center p-0" >
            <h2 className="head-txt-1 text-center w-100 pb-4">
              <div className="heading-box"><span>Shop</span> Smart Phone</div>
            </h2>

            {/* <div className="d-flex justify-content-end align-items-center">
              <div className="less-div mx-2">
                <button
                  className={`less ${activeButton === "previous" ? "active" : ""}`}
                  onClick={handlePrevious}
                  disabled={startIndex === 0}
                >
                  <IoIosArrowForward />
                </button>
              </div>

              <div className="greater-div mx-2">
                <button
                  className={`greater ${activeButton === "next" ? "active" : ""}`}
                  onClick={handleNext}
                  disabled={startIndex + visibleCount >= totalDivs}
                >
                  <IoIosArrowForward />
                </button>
              </div>
            </div> */}
          </div>
          {/* Product Display */}
          <div className="row py-3">
            <Cards product={filteredData.slice(startIndex, startIndex + visibleCount)} />
          </div>
        </Container>
      </section>
    </>
  );
}
